/**
 * Týdenní rozvrh jako jeden řádek textu — „po–pá 08:00–16:00, so 09:00–12:00".
 *
 * Sousední dny se stejným oknem se slučují do rozsahu. Zkratky dnů dává
 * ``Intl`` v jazyce stránky, takže veřejná stránka nepotřebuje vlastní
 * překlady dnů.
 */

import type { WeeklySchedule } from "@/api/queries/admin/machines";

const WEEK = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const;

/** 2024-01-01 bylo pondělí; +i dní = i-tý den týdne. */
function weekdayShort(index: number, locale: string): string {
  const date = new Date(Date.UTC(2024, 0, 1 + index));
  return new Intl.DateTimeFormat(locale, {
    weekday: "short",
    timeZone: "UTC",
  })
    .format(date)
    .replace(/\.$/, "");
}

/** ``null``, když rozvrh nemá jediný otevřený den. */
export function formatWeeklySchedule(
  schedule: WeeklySchedule | null | undefined,
  locale: string,
): string | null {
  if (!schedule) return null;
  const parts: string[] = [];
  let i = 0;
  while (i < WEEK.length) {
    const window = schedule[WEEK[i]!];
    if (!window) {
      i += 1;
      continue;
    }
    let j = i;
    while (
      j + 1 < WEEK.length &&
      schedule[WEEK[j + 1]!]?.from_time === window.from_time &&
      schedule[WEEK[j + 1]!]?.to_time === window.to_time
    ) {
      j += 1;
    }
    const days =
      i === j
        ? weekdayShort(i, locale)
        : `${weekdayShort(i, locale)}–${weekdayShort(j, locale)}`;
    parts.push(`${days} ${window.from_time}–${window.to_time}`);
    i = j + 1;
  }
  return parts.length > 0 ? parts.join(", ") : null;
}
